/** An error from the server with its reason code and details (for example a warning that needs an explanation). */
export class ApiError extends Error {
  constructor(
    message: string,
    public readonly code?: string,
    public readonly details?: unknown,
    public readonly status?: number,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

/** The server could not be reached at all (as opposed to answering with an error). */
export class NoConnectionError extends Error {
  constructor() {
    super("No connection to the server");
    this.name = "NoConnectionError";
  }
}
